import { apiGet, apiPost, apiPatch, apiDelete } from "../api-client"

export interface ManualWBDRecord {
  id: string
  api14: string
  diagram_type: "current" | "planned" | "as_plugged"
  title: string
  diagram_data: Record<string, unknown>
  tenant_id: string
  is_archived: boolean
  created_at: string
  updated_at: string
}

export interface ManualWBDListResponse {
  results: ManualWBDRecord[]
}

export interface CreateManualWBDPayload {
  api14: string
  diagram_type: "current" | "planned" | "as_plugged"
  title?: string
  diagram_data: Record<string, unknown>
}

export interface UpdateManualWBDPayload {
  title?: string
  diagram_data?: Record<string, unknown>
}

const BASE_URL = "/api/tenant/manual-wbd/"

/**
 * List all manual WBD records, optionally filtered by api14 or diagram_type.
 */
export async function listManualWBDs(
  filters?: { api14?: string; diagram_type?: string }
): Promise<ManualWBDListResponse> {
  const params = new URLSearchParams()
  if (filters?.api14) {
    params.set("api14", filters.api14)
  }
  if (filters?.diagram_type) {
    params.set("diagram_type", filters.diagram_type)
  }
  const queryString = params.toString()
  const url = `${BASE_URL}${queryString ? "?" + queryString : ""}`
  return apiGet<ManualWBDListResponse>(url)
}

/**
 * Get a single manual WBD record by ID.
 */
export async function getManualWBD(id: string): Promise<ManualWBDRecord> {
  return apiGet<ManualWBDRecord>(`${BASE_URL}${id}/`)
}

/**
 * Create a new manual WBD record.
 */
export async function createManualWBD(
  payload: CreateManualWBDPayload
): Promise<ManualWBDRecord> {
  return apiPost<ManualWBDRecord>(BASE_URL, payload)
}

/**
 * Update an existing manual WBD record (partial update).
 */
export async function updateManualWBD(
  id: string,
  payload: UpdateManualWBDPayload
): Promise<ManualWBDRecord> {
  return apiPatch<ManualWBDRecord>(`${BASE_URL}${id}/`, payload)
}

/**
 * Delete a manual WBD record by ID.
 */
export async function deleteManualWBD(id: string): Promise<void> {
  await apiDelete<void>(`${BASE_URL}${id}/`)
}
